import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import i18n from './i18n'
import Textra from 'vue-textra'
import VueMeta from 'vue-meta'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  configure
} from "vee-validate";

Vue.use(VueMeta)

Vue.use(Textra);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.config.productionTip = false

import { required, email, max, integer } from "vee-validate/dist/rules";

configure({
  defaultMessage: (field: string, values: Record<string, any>): string => { // eslint-disable-line @typescript-eslint/no-explicit-any
    // override the field name.
    values._field_ = i18n.t(`fields.${field}`);
    return i18n.t(`validation.${values._rule_}`, values) as string;
  }
});

extend("required", required);
extend("email", email);
extend("integer", integer);
extend("max", max);

// use beforeEach route guard to set the language
router.beforeEach( async (to, from, next) => {
  // use the language from the routing param or default language
  let language = to.params.lang
  if (!language) {
    language = 'en'
  }
  i18n.locale = language
  next()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
